import React, { useEffect, useRef, useState } from "react";
import "./InputField.scss";

import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";

import { useClickOutside } from "use-events";

const InputField = ({
  name,
  label,
  required,
  type,
  inputErrors,
  textArea,
  register,
  watch,
  value,
  handleChange,
  disabled,
  constraints,
  classNames,
}) => {
  const inputRef = useRef(null);
  const [active, setActive] = useState(false);

  const [inputType, setInputType] = useState(type);

  const inputWatch = watch(name);

  const handleBlur = () => {
    if (inputWatch === "" && !value) {
      setActive(false);
    }
  };

  useEffect(() => {
    if (inputWatch === "" || inputWatch === null) {
      setActive(false);
    } else {
      setActive(true);
    }
    handleChange && handleChange(inputWatch);
  }, [inputWatch]);

  useEffect(() => {
    if (value) {
      setActive(true);
    }
  }, [value]);

  const handleFocus = () => {
    setActive(true);
  };

  useClickOutside([inputRef], (event) => {
    handleBlur();
  });

  return (
    <div
      className={`custom inputs ${textArea ? "textArea" : ""} ${
        classNames || ""
      }`}
      ref={inputRef}
    >
      <label htmlFor={name} className={active ? "active label" : "label"}>
        {label}
      </label>
      {type === "password" ? (
        inputType === "password" ? (
          <FaRegEye
            onClick={() => {
              setInputType("text");
            }}
          />
        ) : (
          <FaRegEyeSlash
            onClick={() => {
              setInputType("password");
            }}
          />
        )
      ) : (
        <></>
      )}
      {textArea ? (
        <textarea
          autoComplete={`new-${name}`}
          type={inputType}
          name={name}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...register(name, { required: required, ...constraints })}
          disabled={disabled}
        />
      ) : (
        <input
          autoComplete={`new-${name}`}
          value={value}
          type={inputType}
          name={name}
          onFocus={handleFocus}
          onBlur={handleBlur}
          step={"any"}
          disabled={disabled}
          {...register(name, { required: required, ...constraints })}
        />
      )}
      {inputErrors[name]?.type && (
        <p className="error">
          {inputErrors[name].type === "custom"
            ? inputErrors[name].message
            : inputErrors[name].type === "required"
            ? `${label} field is required.`
            : inputErrors[name]?.message || `${label} input is not valid.`}
        </p>
      )}
    </div>
  );
};

export default InputField;
